import { AppMessageTypeEnum } from '../../modules/shared/enums/app-message-type.enum';
import { AuthorizationStatusEnum } from '../model/authorization/authorization-status.enum';

/**
 * Function returns message type for authorization status to display correct message type.
 * @param {AuthorizationStatusEnum} status string
 * @return {AppMessageTypeEnum}
 */
export function getAppMessageType(status: AuthorizationStatusEnum): AppMessageTypeEnum {
    switch (status) {
        case AuthorizationStatusEnum.AUTHORIZED:
            return AppMessageTypeEnum.SUCCESS;
        case AuthorizationStatusEnum.NEW:
        case AuthorizationStatusEnum.AUTHORIZED_INSUFFICIENT_RISKLEVEL:
        case AuthorizationStatusEnum.NOT_AUTHORIZED_LIMIT:
        case AuthorizationStatusEnum.EXPIRED:
        case AuthorizationStatusEnum.CANCELLED:
            return AppMessageTypeEnum.WARNING;
        default:
            return AppMessageTypeEnum.WARNING;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/helpers/status-to-type.helper.ts